import React, { useState, useMemo } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useApp } from './appContext';

export default function OneTimeNotificationModal() {
	const { user, dismissOneTimeNotification } = useApp();
	const [dismissing, setDismissing] = useState(false);

	const shouldShow = useMemo(() => {
		if (!user || !user.tenant) return false;
		const key = user.tenant.oneTimeNotificationKey;
		const text = user.tenant.oneTimeNotification;
		if (!key || !text) return false;
		return user.lastSeenTenantOneTimeNotificationKey !== key;
	}, [user]);

	if (!shouldShow) return null;

	const handleDismiss = async () => {
		try {
			setDismissing(true);
			await dismissOneTimeNotification();
		} finally {
			setDismissing(false);
		}
	};

	return (
		<Modal isOpen={true} toggle={dismissing ? undefined : handleDismiss} centered>
			<ModalHeader toggle={dismissing ? undefined : handleDismiss}>
				<i className="fa fa-bullhorn" style={{ marginRight: 8, color: '#667eea' }}></i>
				What's new
			</ModalHeader>
			<ModalBody style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
				{user.tenant.oneTimeNotification}
			</ModalBody>
			<ModalFooter>
				<Button color="primary" onClick={handleDismiss} disabled={dismissing}>
					{dismissing ? 'Saving…' : 'Got it'}
				</Button>
			</ModalFooter>
		</Modal>
	);
}
